import { render, staticRenderFns } from "./RbxTextEditor.vue?vue&type=template&id=28ee802c&"
import script from "./RbxTextEditor.vue?vue&type=script&lang=js&"
export * from "./RbxTextEditor.vue?vue&type=script&lang=js&"
import style0 from "./RbxTextEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RbxTextEditor.vue"
export default component.exports